import { faComment } from "@fortawesome/free-solid-svg-icons";
import { isDefinedString } from "et3-type-guards";
import { getSelectedEventData } from "../../../../helpers/et3-get-selected-event-data";
import getAuditStore from "../../../../stores/auditor-store/audit-store";
import getTBWStore from "../../../../stores/developer-store/tbw-store";
import Et3Button from "../../../et3-button";
import { withLiteObserverAndTheme } from "../../../et3-enhanced-render";
import Et3TextInput from "../../../et3-input/et3-text-input";
import React from "react";
import ET3Div from "../../../et3-div";
import i18n from "../../../../constants/i18n";

const AuditProofPopUp = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const status = getTBWStore().TBWAuditIssue.get();
  const { userIDNumber, userUUID, eventIDNumber, eventType, imageID } =
    getSelectedEventData();
  const isEnabled = isDefinedString(getTBWStore().auditEventProof.get());

  return (
    <React.Fragment>
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"textarea"}
        icon={faComment}
        label={i18n.get("INSERT_PROOF")}
        placeHolder={i18n.get("INSERT_PROOF")}
        value={getTBWStore().auditEventProof.get()}
        onChoose={(value: string) => getTBWStore().auditEventProof.set(value)}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{}}
      />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="space-around"
        alignItems="center"
        withShadow={false}
        width={1000}
        height={100}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Button
          isEnabled={isEnabled}
          onClick={async () => {
            if (getTBWStore().TBWSaveButtonDisabled.get()) {
              getTBWStore().TBWSaveButtonDisabled.set(false);
              await getAuditStore().takeAuditAction({
                actionType: status === "minor" ? "minor" : "major",
                userID: userIDNumber,
                userUUID,
                eventID: eventIDNumber,
                eventType,
                imageID: `${imageID}`
              });
            }
          }}
          size="MEDIUM"
          text="SAVE"
          type="APPROVE"
        />
      </ET3Div>
    </React.Fragment>
  );
});
export default AuditProofPopUp;
